import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/common';

/**
 * Scenario entry point only. SIP engine deployment and discovery are external
 * operations; engine configuration starts from the discovered identity in
 * SIP Engines rather than from a pre-deployment form.
 */
export function OnboardingPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Guided setup"
        description="Deploy the SIP engine externally, configure its discovered identity, then set up peers and routing."
      />

      <section className="rounded-lg border border-blue-200 bg-blue-50 p-4 text-sm text-blue-900">
        <p className="font-medium">Start with SIP Engines</p>
        <p className="mt-1">
          Deploy the SIP engine first. It will appear automatically after it reports its existing logical identity.
          Then choose Configure or View details from <Link className="font-medium underline" to="/system/containers">SIP Engines</Link>.
        </p>
      </section>

      <section className="rounded-lg border bg-white p-6 space-y-3">
        <h2 className="text-lg font-semibold">Scenario guides</h2>
        <p className="text-sm text-gray-600">These guides configure peers, SIP policies, and routes for an existing SIP engine. They do not deploy or create an engine identity.</p>
        <div className="flex flex-wrap gap-4 text-sm">
          <Link to="/onboarding/carrier-trunk" className="text-blue-700">Carrier trunk setup →</Link>
          <Link to="/onboarding/teams-direct-routing" className="text-blue-700">Teams Direct Routing setup →</Link>
          <Link to="/onboarding/softphone-registration" className="text-blue-700">Softphone setup →</Link>
        </div>
      </section>
    </div>
  );
}
